/**
 * AmazonService — STUB v1.12.485 (RapidAPI désactivé)
 */
export async function searchAmazonProducts() { return []; }
export async function getAmazonProducts() { return []; }
export async function getAmazonProductDetails() { return null; }
export async function getAmazonProductOffers() { return null; }
